import { createRoute } from "@tanstack/react-router";
import { errorLayoutRoute } from "../__root";
import { ROUTER_HELPERS } from "@/shared/constants/router";
import GeneralError from "@/components/errors/general-error";

export const generalErrorRoute = createRoute({
  getParentRoute: () => errorLayoutRoute,
  path: ROUTER_HELPERS.error(500),
  component: GeneralError,
});
